'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$() {
  this.aMR = null;
  this.aN8 = null;
  this.aMU = null;
  this.aMV = false;
  this.aN0 = null;
  this.aN1 = false;
  this.aN6 = null;
  this.aN7 = false;
  this.aMS = null;
  this.aMT = false;
  this.aN4 = null;
  this.aN5 = false;
  this.aN2 = null;
  this.aN3 = false;
  this.aMW = null;
  this.aMX = false;
  this.aMY = null;
  this.aMZ = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ = this;
  this.aMR = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$();
  this.aN8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aMR;
});
$p.eO = (function() {
  return this.aN8;
});
$p.bW = (function() {
  if ((!this.aMV)) {
    this.aMU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aMV = true;
  }
  return this.aMU;
});
$p.b9 = (function() {
  if ((!this.aN1)) {
    this.aN0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aN1 = true;
  }
  return this.aN0;
});
$p.b3 = (function() {
  if ((!this.aN7)) {
    this.aN6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aN7 = true;
  }
  return this.aN6;
});
$p.aG = (function() {
  if ((!this.aMT)) {
    this.aMS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aMT = true;
  }
  return this.aMS;
});
$p.az = (function() {
  if ((!this.aN5)) {
    this.aN4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aN5 = true;
  }
  return this.aN4;
});
$p.aY = (function() {
  if ((!this.aN3)) {
    this.aN2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aN3 = true;
  }
  return this.aN2;
});
$p.Jg = (function() {
  if ((!this.aMX)) {
    this.aMW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Manufacturer";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aMX = true;
  }
  return this.aMW;
});
$p.bsj = (function() {
  if ((!this.aMZ)) {
    this.aMY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aMZ = true;
  }
  return this.aMY;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$, "app.data.data_point_types$package$ManufacturerNameForm$", ({
  G6: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$() {
  this.aMP = null;
  this.aMQ = false;
  this.aMN = null;
  this.aMO = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aMQ)) {
    this.aMP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aMQ = true;
  }
  return this.aMP;
});
$p.bs1 = (function() {
  if ((!this.aMO)) {
    this.aMN = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerNameForm$().Jg();
    this.aMO = true;
  }
  return this.aMN;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$, "app.data.data_point_types$package$ManufacturerName$", ({
  G5: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ManufacturerName$ };
//# sourceMappingURL=app.data.data_point_types$package$-Manufacturer-Name$.js.map
